type ProjectReportField = {
  name: string;
  type: string;
  order: number;
  criteriaId?: string;
};

const projectReportField: ProjectReportField = {
  name: "",
  type: "",
  order: 0,
};

export type { ProjectReportField };

export { projectReportField };
